import {createUseStyles} from 'react-jss'

export const useStyles = createUseStyles({
    container: {
        fontSize: "16px",
        '& hr': {
            borderTop: "1px solid rgba(0,0,0,1)"
        },
        '& .btn': {
            fontSize: "1rem",
            fontWeight: 400,
            padding: ".375rem .75rem",
            lineHeight: 1.5
        },
        '& .form-control': {
            fontSize: "1rem"
        },
        '& .form': {
            padding: "1.5rem !important"
        }
    },
    '@global': {
        body: {
            fontFamily: "'Open Sans', sans-serif",
            backgroundColor: "white !important",
            '&.darkMode': {
                backgroundColor: "rgb(22, 26, 29) !important",
                color: "white",
                '&.navbar': {
                    backgroundColor: "rgb(45, 53, 60)"
                }
            },
            '& .container': {
                width: "100%",
                maxWidth: "1300px",
                marginRight: "auto",
                marginLeft: "auto",
            },
            // '& .navbar .btn-danger': {
            //     borderWidth: "1px",
            //     borderColor: "#e13019",
            //     borderRadius: "5px",
            //     backgroundColor: "#e13019"
            // },
            "& .navbar .btn":{"marginTop":"20px","padding":"12px 32px","WebkitBoxPack":"center","WebkitJustifyContent":"center","MsFlexPack":"center","justifyContent":"center","WebkitBoxAlign":"center","WebkitAlignItems":"center","MsFlexAlign":"center","alignItems":"center","borderStyle":"solid","borderWidth":"1px","borderRadius":"5px","WebkitTransition":"all 200ms ease","transition":"all 200ms ease","fontSize":"1em","lineHeight":"1.5","fontWeight":"600","textAlign":"center"},
            '& .navbar': {
                position: "absolute",
                left: "0%",
                top: "0%",
                right: "0%",
                bottom: "auto",
                zIndex: 9999,
                padding: "10px 5vw",
                fontSize: "16px",
                backgroundColor: "#001540"
                // backgroundImage: "url(/images/blue-bk-hex.png)",
                // backgroundPosition: "50% 11%",
                // backgroundSize: "cover"
            },
            '& .cover-caption': {
                width: "100%",
                position: "relative",
                zIndex: 1
            },
            '& .container-padded': {
                padding: "140px 5vw 40px",
            },
            // '& #page-container': {
            //     display: "flex",
            //     alignItems: "center",
            //     position: "relative",
            //     backgroundSize: "cover",
            //     height: "100%"
            // },
            '& .page-header-fixed': {
                paddingTop:"0px"
            }
        },
        [`@media screen and (max-width: 991px)`]: {
            ".navbar-brand img": {
                height: "60px !important"
            }
        },
        [`@media screen and (max-width: 576px)`]: {
            ".navbar .btn": {
                fontSize: "12px !important",
                fontWeight: "600",
                lineHeight: "20px",
                padding: "6px 12px !important"
            }
        },
        '@font-face': [
            {
                fontFamily: 'Tw Cen MT Std',
                src: "url('/assets/css/fonts/TwCenMTStdSemiBold.otf') format('opentype')",
                fontWeight: 600,
                fontStyle: "normal",
                fontDisplay: "swap"
            }, {
                fontFamily: 'Tw Cen MT Std',
                src: "url('/assets/css/fonts/TwCenMTStd.otf') format('opentype')",
                fontWeight: 400,
                fontStyle: "normal",
                fontDisplay: "swap",
            }, {
                fontFamily: 'Tw Cen MT Std',
                src: "url('/assets/css/fonts/TwCenMTStd-Bold.otf') format('opentype'), url('/assets/css/fonts/TwCenMTStd-ExtraBold.otf') format('opentype')",
                fontWeight: 700,
                fontStyle: "normal",
                fontDisplay: "swap",
            }
        ]
        // [`@media screen and (max-width: 767px)`]: {
        //     "#page-container": {
        //         height:"auto"
        //     }
        // }
    }
    
})